<template>
  <div class="maps-wrapper">
    <div class="google-maps-wrapper" id="map"></div>
  </div>
</template>

<script>
import { Loader } from "@googlemaps/js-api-loader";
const google = window.google;

export default {
  props: {
    participantsSelected: [Array, String],
    rawData: { default: null },
    sitesSelected: [Array, String],
    countrySelected: [Array, String],
    countryList: { type: Array, default: () => [] },
    allSiteList: { type: Array, default: () => [] },
    zoomValue: Number,
    statusSelected: Array,
    apiKey: {
      type: String,
      default: "default-gmaps-api-key"
    }
  },
  data() {
    return {
      countrySite: false,
      rawDatas: null,
      newCountrySelected: "all",
      conversion: [],
      zoom: null,
      google: null,
      map: null,
      loader: new Loader({
        apiKey: process.env.VUE_GOOGLE_MAPS_API_KEY,
        libraries: ["places"]
      }),
      mapOptions: {
        center: {
          lat: 45.456784,
          lng: -43.106576
        },
        restriction: {
          latLngBounds: {
            north: (Math.atan(Math.sinh(Math.PI)) * 180) / Math.PI,
            south: -((Math.atan(Math.sinh(Math.PI)) * 180) / Math.PI),
            west: -180,
            east: 180
          },
          strictBounds: true
        },
        styles: [
          {
            featureType: "water",
            elementType: "geometry",
            stylers: [
              {
                color: "#d3dee3"
              },
              {
                lightness: 17
              }
            ]
          },
          {
            featureType: "landscape",
            elementType: "geometry",
            stylers: [
              {
                color: "#ffffff"
              },
              {
                lightness: 20
              }
            ]
          },
          {
            featureType: "administrative",
            elementType: "geometry",
            stylers: [{ visibility: "off" }]
          },
          {
            elementType: "labels",
            stylers: [
              {
                visibility: "off"
              }
            ]
          },
          {
            featureType: "administrative.land_parcel",
            stylers: [
              {
                visibility: "off"
              }
            ]
          },
          {
            featureType: "administrative.neighborhood",
            stylers: [
              {
                visibility: "off"
              }
            ]
          },
          {
            featureType: "road",
            stylers: [
              {
                visibility: "off"
              }
            ]
          },
          {
            featureType: "road",
            elementType: "labels.icon",
            stylers: [
              {
                visibility: "off"
              }
            ]
          },
          {
            featureType: "road.highway",
            elementType: "geometry.fill",
            stylers: [
              {
                visibility: "off"
              }
            ]
          },
          {
            featureType: "transit",
            stylers: [
              {
                visibility: "off"
              }
            ]
          },
          {
            elementType: "labels",
            stylers: [
              {
                visibility: "off"
              }
            ]
          },
          {
            featureType: "administrative.country",
            elementType: "geometry.stroke",
            stylers: [
              {
                color: "#868686"
              },
              {
                visibility: "on"
              }
            ]
          },
          {
            featureType: "poi",
            stylers: [
              {
                visibility: "off"
              }
            ]
          }
        ],
        zoomControl: true,
        disableDefaultUI: true,
        streetViewControl: false
      }
    };
  },
  watch: {
    countrySelected: async function(newValue) {
      this.countrySite = false;
      this.newCountrySelected = newValue;
    },
    sitesSelected: async function(newValue) {
      this.countrySite = false;
      if (!(this.conversion == 0)) {
        this.conversion.splice(0, this.conversion.length);
      }
      this.allsites = newValue;
      await this.maprender();
    },
    participantsSelected: function() {
      this.countrySite = true;
    },
    zoomValue: function(value) {
      this.zoomValue = value;
      this.map.setZoom(this.zoomValue);
    },
    rawData: async function(value) {
      if (!(this.conversion == 0)) {
        this.conversion.splice(0, this.conversion.length);
      }
      this.rawDatas = value;
      this.maprender();
    }
  },
  mounted() {
    this.maprender();
  },
  methods: {
    filterformap: async function() {
      const countrySelected = this.countrySelected == "all" ? this.countryList : this.countrySelected;
      const siteSelected = this.sitesSelected == "all" ? this.allSiteList : this.sitesSelected;
      if (!this.countrySite) {
        const rawData = this.rawData;
        for (const k in countrySelected) {
          for (const i in rawData) {
            if (countrySelected[k] == i) {
              for (const l in siteSelected) {
                for (let j in rawData[i]) {
                  if (siteSelected[l] == j) {
                    const siteanme = j;
                    const alldata = rawData[i][j];
                    const temp = {
                      siteanme: siteanme,
                      ...alldata
                    };
                    this.conversion.push(temp);
                  }
                }
              }
            }
          }
        }
      } else {
        const rawData = this.rawDatas;
        for (let j in rawData) {
          for (const p in rawData[j]) {
            const siteanme = p;
            const alldata = rawData[j][p];
            const temp = {
              siteanme: siteanme,
              ...alldata
            };
            this.conversion.push(temp);
          }
        }
      }
    },
    maprender() {
      this.initMap(this.conversion);
    },
    initMap(countryLists) {
      this.loader.load().then(google => {
        this.map = new google.maps.Map(document.getElementById("map"), this.mapOptions);
        this.filterformap();
        const bounds = new google.maps.LatLngBounds();
        const arrcont = [];
        let infoWindow = null;
        const map = this.map;
        map.setOptions({ minZoom: 1.6, maxZoom: 6 });
        const sitesdatagmap = [];

        function handlesites(cityCircle, map) {
          const finalstructuredata = [];
          let finalpush = [];
          function arePointsNear(checkPoint, centerPoint, km) {
            const ky = 40000 / 360;
            const kx = Math.cos((Math.PI * centerPoint.lat) / 180.0) * ky;
            const dx = Math.abs(centerPoint.lng - checkPoint.lng) * kx;
            const dy = Math.abs(centerPoint.lat - checkPoint.lat) * ky;
            const dx2 = dx * dx;
            const dy2 = dy * dy;
            const matLog = Math.sqrt(dx2 + dy2) <= km;
            for (const countries in arrcont) {
              const lat = arrcont[countries].lat;
              const lng = arrcont[countries].lng;
              const stockholm = { lat, lng };
              if (matLog && centerPoint.lat == stockholm.lat && centerPoint.lng == stockholm.lng) {
                const complaintesrate = arrcont[countries].persentsge;
                const totalpartisipantes = arrcont[countries].Participants;
                const sitename = arrcont[countries].sitename;
                const structuring = {
                  complaintesrate,
                  totalpartisipantes,
                  sitename
                };
                if (!(finalstructuredata.some(sitenames => sitenames.sitename === sitename) && finalstructuredata.some(totalpartisipantess => totalpartisipantess.totalpartisipantes === totalpartisipantes) && finalstructuredata.some(complaintesrates => complaintesrates.complaintesrate === complaintesrate))) {
                  finalstructuredata.push(structuring);
                }

                const anothertemp = [];
                for (const mapstructuredata in finalstructuredata) {
                  const Toltiprendering = "<div style='margin-top: 5px;'>" + "<div>Site: " + `${finalstructuredata[mapstructuredata].sitename}` + "</div> " + "<div>Compliance Rate: " + `${finalstructuredata[mapstructuredata].complaintesrate}` + "%" + "</div>" + "<div>Total Participants: " + `${finalstructuredata[mapstructuredata].totalpartisipantes}` + "</div>" + "</div>";
                  anothertemp.push(Toltiprendering);
                }
                finalpush = anothertemp;
              }
            }
          }
          function latlongextract(circledatalatlong) {
            const lat = circledatalatlong.center.lat();
            const lng = circledatalatlong.center.lng();
            const radius = circledatalatlong.radius;
            const rtok = radius / 1000;
            const vasteras = { lat, lng };
            for (const countries in arrcont) {
              const lat = arrcont[countries].lat;
              const lng = arrcont[countries].lng;
              const stockholm = { lat, lng };
              arePointsNear(vasteras, stockholm, rtok);
            }
          }

          function handlesitefinal(cityCircle, map, finalpush) {
            let content;
            if (finalstructuredata.length >= 3) {
              content = '<div style="flex-grow: 0;height: 120px;font-family: Roboto;font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: 1.2;letter-spacing: normal;text-align: left;color: #2d3752;">' + `${finalpush}` + "</div>";
            } else {
              content = '<div style="flex-grow: 0;font-family: Roboto;font-size: 10px;font-weight: normal;font-stretch: normal;font-style: normal;line-height: 1.2;letter-spacing: normal;text-align: left;color: #2d3752;">' + `${finalpush}` + "</div>";
            }
            infoWindow = new google.maps.InfoWindow({
              content,
              position: cityCircle.center,
              maxWidth: 200
            });
            infoWindow.open(map, cityCircle);
          }
          google.maps.event.addListener(cityCircle, "mouseover", function() {
            finalstructuredata.length = 0;
            finalpush.length = 0;
            latlongextract(cityCircle);
            let finalpushtemp = "";
            for (const hgd in finalpush) {
              finalpushtemp = finalpush[hgd] + finalpushtemp;
            }
            handlesitefinal(cityCircle, map, finalpushtemp);
          });

          google.maps.event.addListener(cityCircle, "mouseout", function() {
            infoWindow.close();
          });
        }

        function circle(sitesdatagmap) {
          for (let sitedata in sitesdatagmap) {
            const Site = sitesdatagmap[sitedata].Site;
            const Participants = sitesdatagmap[sitedata].Participants;
            const persentsge = sitesdatagmap[sitedata].persentsge;
            const address = sitesdatagmap[sitedata].address;
            const circlecolors = sitesdatagmap[sitedata].circlecolors;
            const radius = sitesdatagmap[sitedata].radius;
            const sitename = sitesdatagmap[sitedata].sitename;
            let geocoder = new google.maps.Geocoder();
            geocoder.geocode({ address }, function(results, status) {
              if (status == google.maps.GeocoderStatus.OK && !(sitesdatagmap[sitedata].address == undefined)) {
                const cityCircle = new google.maps.Circle({
                  strokeColor: circlecolors,
                  strokeOpacity: 0.8,
                  strokeWeight: 0,
                  fillColor: circlecolors,
                  fillOpacity: 2,
                  map,
                  center: {
                    lat: results[0].geometry.location.lat(),
                    lng: results[0].geometry.location.lng()
                  },
                  radius
                });
                arrcont.push({
                  Site,
                  constryname: address,
                  persentsge,
                  Participants,
                  lat: results[0].geometry.location.lat(),
                  lng: results[0].geometry.location.lng(),
                  radius,
                  sitename
                });
                handlesites(cityCircle, map);
              }
            });
          }
        }
        for (const city in countryLists) {
          const Site = countryLists[city].city;
          const Participants = countryLists[city].nParticipant;
          const persentsge = Math.round(Number(countryLists[city].complianceRate));
          const address = countryLists[city].city;
          const sitename = countryLists[city].siteanme;
          const dumyradius = Math.round(Number(countryLists[city].participantPercentage));
          let circleColorsPo = "";
          if (persentsge <= 20) {
            circleColorsPo = "#fff2e2";
          } else if (persentsge <= 40) {
            circleColorsPo = "#fee5c5";
          } else if (persentsge <= 60) {
            circleColorsPo = "#fed9a9";
          } else if (persentsge <= 80) {
            circleColorsPo = "#fecc8c";
          } else if (persentsge <= 100) {
            circleColorsPo = "#fdbf6f";
          } else {
            circleColorsPo = "#fff2e2";
          }
          let radiusup;
          if (dumyradius <= 20) {
            radiusup = 156888;
          } else if (dumyradius <= 40) {
            radiusup = 262138;
          } else if (dumyradius <= 60) {
            radiusup = 377377;
          } else if (dumyradius <= 80) {
            radiusup = 487377;
          } else if (dumyradius <= 100) {
            radiusup = 597377;
          } else {
            radiusup = 156888;
          }
          const circlecolors = circleColorsPo;
          const radius = radiusup;
          const place = countryLists[city].country;
          let geocoder = new google.maps.Geocoder();
          geocoder.geocode({ address }, function(results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
              const cityCircle = new google.maps.Circle({
                zIndex: Number(600000 - radius),
                position: new google.maps.LatLng(results[0].geometry.location.lat(), results[0].geometry.location.lng()),
                strokeColor: circlecolors,
                strokeOpacity: 0.8,
                strokeWeight: 0,
                fillColor: circlecolors,
                fillOpacity: 2,
                map,
                center: {
                  lat: results[0].geometry.location.lat(),
                  lng: results[0].geometry.location.lng()
                },
                radius
              });
              arrcont.push({
                Site,
                constryname: address,
                persentsge,
                Participants,
                circlecolors,
                lat: results[0].geometry.location.lat(),
                lng: results[0].geometry.location.lng(),
                radius,
                sitename
              });
              handlesites(cityCircle, map);
              // set boundries here
              bounds.union(cityCircle.getBounds());
              map.fitBounds(bounds);
            } else {
              sitesdatagmap.push({
                address: place,
                Site,
                Participants,
                persentsge,
                circlecolors,
                radius,
                sitename
              });
              circle(sitesdatagmap);
            }
          });
        }
      });
    }
  }
};
</script>
<style lang="scss">
.google-maps-wrapper {
  height: 100%;
  width: 100%;
  min-height: 100%;
}
.maps-wrapper {
  @extend .google-maps-wrapper;
  border-radius: 8px;
  overflow: hidden;
}
button.gm-ui-hover-effect {
  visibility: hidden;
}
.gm-style .gm-style-iw-c {
  padding-top: 5px;
  position: absolute;
  box-sizing: border-box;
  overflow: hidden;
  transform: translate3d(-50%, -100%, 0);
  background-color: #fecc8c;
  border-radius: 8px;
  padding: 0px;
  padding-bottom: 0px;
  padding-top: 2px;
  padding-right: 8px;
  padding-left: 8px;
}
track,
.gm-style .gm-style-iw-d::-webkit-scrollbar-track-piece {
  background: #fecc8c;
}
.gm-style .gm-style-iw-d::-webkit-scrollbar-track,
.gm-style .gm-style-iw-d::-webkit-scrollbar-track-piece {
  background: #fecc8c;
}
.gm-style .gm-style-iw-t::after {
  background: #fecc8c;
  content: "";
  height: 15px;
  left: 0;
  position: absolute;
  top: 0;
  transform: translate(-50%, -50%) rotate(-45deg);
  width: 15px;
}
.gm-style .gm-style-iw #google-popup p {
  padding: 10px;
}
</style>
